import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';

type QuerySliceState = {
  customerQueries?: URLSearchParams;
};

const initialState: QuerySliceState = {
  customerQueries: undefined,
};

export const querySlice = createSlice({
  name: 'query',
  initialState,
  reducers: {
    setQueries: (state, action) => {
      state.customerQueries = action.payload;
    },
  },
});

export const getState = (rootState: RootState) => rootState.constants;
export const { setQueries } = querySlice.actions;
